import React, { useState, useEffect, useRef } from "react";
import { enUS } from "date-fns/locale";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";

const DateRangeSelector = ({ selectedDates }) => {
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });

  const inputRef = useRef(null);
  const calendarRef = useRef(null);
  const handleInputClick = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setCalendarPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
    setShowCalendar(true);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const sendDateToParent = () => {
    // if (selectedDates) {
      selectedDates(selectionRange);
    // }
  };
  useEffect(() => {
    sendDateToParent();
  }, [selectionRange]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRange(ranges.selection);

    // Only close calendar if both dates are selected
    if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
      setShowCalendar(false);
    }

    setSelectionRange(ranges.selection);

    // Close the calendar only if both dates are selected and they are distinct
    if (startDate < endDate) {
      setShowCalendar(false);
    }
  };
  return (
    <>
      <input
        ref={inputRef}
        type="text"
        value={`${selectionRange.startDate.toLocaleDateString()} - ${selectionRange.endDate.toLocaleDateString()}`}
        readOnly
        onClick={handleInputClick}
        style={{
          cursor: "pointer",
          padding: "8px",
          width: "250px",
        }}
      />

      {showCalendar && (
        <div
          ref={calendarRef}
          style={{
            position: "absolute",
            top: calendarPosition.top,
            left: calendarPosition.left,
            zIndex: 1000,
          }}
        >
          <DateRange
            ranges={[selectionRange]}
            onChange={handleSelect}
            locale={enUS}
            staticRanges={[]}
            inputRanges={[]}
          />
        </div>
      )}
    </>
  );
};

export default DateRangeSelector;
